import React, { useState, useEffect } from "react";
import axios from "axios";
import SearchForm from "./components/SearchForm";
import Results from "./components/Results";


const App = () => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const API_URL = process.env.REACT_APP_CHECK_STATUS;

  useEffect(() => {
    document.title = `Проверка по Реестру перевозчиков Республики Беларусь, 
    допущенных к осуществлению международных перевозок грузов`;
  });

  const handleSearch = async (identif, weight) => {
    setResults([]);
    setError(null);
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/api`, {
        params: {
          identif: identif,
          weight: weight,
        },
      });
      setResults(response.data);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setError("Пожалуйста, проверьте правильность введенных данных. По указанному УНП не получено ответа.");
      } else {
        setError("Ошибка при получении данных. Пожалуйста, попробуйте еще раз.");
      }
      console.error("Ошибка получения данных:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h1>Проверка по Реестру перевозчиков Республики Беларусь, <br/> допущенных к осуществлению международных перевозок грузов</h1>
      <SearchForm onSearch={handleSearch} />
      {loading ? <p>Загрузка...</p> : <Results results={results} />}
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
};

const styles = {
  container: {
    padding: "20px",
    textAlign: "center",
  },
};

export default App;